/**
 * Single source of truth for the project lifecycle dropdown.
 * Both the Master Board quick editor and the Manager Board quick status
 * editor import from here so the two boards always show the same options.
 */
export const LIFECYCLE_STAGES = [
  ["complete", "Complete"],
  ["not_started", "Not Started"],
  ["blocked", "Roadblocked"],
  ["in_progress", "In Progress"],
];

/**
 * Returns the lifecycle choices that should be shown to the current user
 * for the given project. Mirrors the logic used on the Master Board:
 *   - Billing-eligible users see every stage, plus "Closed" when the
 *     current state is "complete".
 *   - Others see only stages the backend already permits via the
 *     `available_lifecycle_transitions` array, plus the current stage.
 */
export function lifecycleStageChoices(project, { canAccessBilling = false } = {}) {
  if (canAccessBilling) {
    return project?.lifecycle_state === "complete"
      ? [...LIFECYCLE_STAGES, ["closed", "Closed"]]
      : LIFECYCLE_STAGES;
  }
  const currentStage = project?.lifecycle_state || project?.official_status || project?.operational_status;
  const allowed = project?.available_lifecycle_transitions || [];
  return LIFECYCLE_STAGES.filter(
    ([value]) => value === currentStage || allowed.includes(value),
  );
}
